import { useState } from "react";
import { FaCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import { Button } from "../../../components/Button";
import { Spacer } from "../../../components/Spacer";
import { Rings } from "../../../components/Svg/Rings";
import { FadeUp } from "../../../components/Transitions/FadeUp";
import { useIsDesktop } from "../../../hooks/useIsDesktop";

const IBAN = "ES79 1583 0001 1591 0266 6885";

export const GiftInfo = () => {
  const md = useIsDesktop();
  const [busy, setBusy] = useState(false);

  const handleCopy = async () => {
    setBusy(true);
    await navigator.clipboard.writeText(IBAN);

    toast("¡IBAN copiado en el portapapeles!");

    setTimeout(() => {
      setBusy(false);
    }, 1000);
  };

  return (
    <FadeUp>
      <div className="">
        <div className="">
          <div className="max-w-5xl m-auto text-primary-text card rounded-4xl bg-white p-6">
            {/* <div className="max-w-5xl rounded-4xl border border-white/16 bg-[linear-gradient(145deg,rgba(255,255,255,0.16),rgba(255,255,255,0.08))] p-6 m-auto text-secondary-light shadow-[0_24px_70px_rgba(84,83,58,0.16)] md:p-10"> */}
            <p className="text-lg leading-relaxed md:text-xl">
              Vuestra presencia es lo más importante para nosotros. Si aun así
              deseáis hacernos un regalo, podéis hacerlo a la siguiente cuenta:
            </p>

            <Spacer />

            <div className="md:grid md:grid-cols-2 md:gap-8 ">
              <div className="mt-2">
                <div className="pb-6">
                  <div className="text-xl md:text-2xl font-bold pb-2">
                    Beneficiarios
                  </div>
                  <div className="text-lg md:text-xl">Natalia y David</div>
                </div>

                <div>
                  <div className="text-xl md:text-2xl font-bold flex flex-row items-center pb-2">
                    <span className="mr-5">IBAN</span>
                    <div className="text-base ml-auto ">
                      <Button
                        icon={<FaCopy size={14} />}
                        bgColor="secondary-light"
                        textColor="primary-text"
                        action={handleCopy}
                        disabled={busy}
                        className="shadow-md"
                      >
                        Copiar
                      </Button>
                    </div>
                  </div>
                  <div className="mt-3 w-full rounded-2xl border border-primary-text/20 bg-secondary-light/20 px-4 py-4 text-base tracking-[0.12em] md:text-lg">
                    <div>{IBAN}</div>
                  </div>

                  <div className="mt-3 text-sm">
                    <span className="font-bold opacity-75">BIC o SWIFT:</span>{" "}
                    <span>REVOESM2</span>
                    <div className="text-lg md:text-xl font-bold pb-2"></div>
                  </div>

                  <div className="mt-1 text-sm">
                    <span className="font-bold opacity-75">
                      BIC banco corresponsal:
                    </span>{" "}
                    <span>CHASDEFX</span>
                    <div className="text-lg md:text-xl font-bold pb-2"></div>
                  </div>
                </div>
              </div>
              {md && (
                <div className="flex justify-center md:justify-end items-center mt-6 md:mt-0">
                  <Rings width="135px" color="var(--color-primary-text)" />
                </div>
              )}
            </div>
          </div>
          {!md && (
            <div className="flex justify-center md:justify-end items-center mt-6 md:mt-0">
              <Rings width="135px" color="var(--color-primary-text)" />
            </div>
          )}
        </div>
      </div>
    </FadeUp>
  );
};
